import Modal from "@atoms/Modal/Modal";

import * as S from "./DeletedPressModal.style";

type Props = {
  closeModal: () => void;
  type?: "press" | "publication" | "ctg";
};

const DeletedPressModal = ({ closeModal, type = "press" }: Props) => {
  const TYPE_CONTENTS = {
    press: {
      title: "Deleted Press",
      text: "This press has been deleted. Please check other press items.",
    },
    publication: {
      title: "Deleted Publication",
      text: "This publication has been deleted. Please check other publication items.",
    },
    ctg: {
      title: "Deleted CTG",
      text: "This ctg has been deleted. Please check other ctg items.",
    },
  };

  const { title, text } = TYPE_CONTENTS[type];

  return (
    <Modal closeModal={closeModal}>
      <S.ModalContentsWrapper>
        <S.ModalTitle>{title}</S.ModalTitle>
        <S.ModalText>{text}</S.ModalText>
        <S.ModalButtonWrapper>
          <S.CancelButton type="button" onClick={closeModal}>
            OK
          </S.CancelButton>
        </S.ModalButtonWrapper>
      </S.ModalContentsWrapper>
    </Modal>
  );
};

export default DeletedPressModal;
